var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"container container-fluid bg--cardio"},[_c('h1',{staticClass:"pull-left text-muted"},[_vm._v("Alla kardiologpatienter - "+_vm._s(_vm.noOfAllCardioPatients)+" st")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/newcardio"}},[_c('button',{staticClass:"btn btn-info btn-sm top-right"},[_vm._v("Skapa ny kardiologpatient")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.allCardioPatients,"search-options":{
        enabled: true,
        placeholder: 'Sök',
      },"pagination-options":{
        enabled: true,
        perPage: 50,
        position: 'top',
        firstLabel : 'Första sidan',
        lastLabel : 'Sista sidan',
        nextLabel: 'Nästa',
        prevLabel: 'Föregående',
        rowsPerPageLabel: 'Patienter per sida',
        ofLabel: 'av',
        pageLabel: 'sida',
        allLabel: 'Alla'
      },"sort-options":{
        enabled: true,
        initialSortBy: [
          { field: 'personId', type: 'asc' } ]
      }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'personId')?_c('span',[(props.row.personId)?_c('router-link',{attrs:{"to":{ name: 'patientcardio', params: { id: (props.row.personId) }}}},[_vm._v("\n            "+_vm._s(props.row.personId)+"\n          ")]):_vm._e()],1):(props.column.field == 'ssn')?_c('span',[_c('details',[_c('summary',[_vm._v("Personnummer")]),_vm._v("\n            "+_vm._s(_vm.formatPnr(props.row.ssn))+"\n          ")])]):_c('span',[_vm._v("\n          "+_vm._s(props.formattedRow[props.column.field])+"\n        ")])]}}])},[_vm._v(" "),_c('div',{attrs:{"slot":"emptystate"},slot:"emptystate"},[_vm._v("\n        Det finns inga kardiologpatienter\n      ")])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36378382","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AllPatientsCardio.vue
// module id = null
// module chunks = 